module.exports = __webpack_public_path__ + "img/Icon_ImportantText.901328d5.svg";